import React, { useEffect, useState } from "react";
import axios from "axios";
import { ChevronDown } from 'lucide-react';
import API_ENDPOINTS from "../../../service/api";
import coin from "../../../assets/ProfileCardimg/coin.jpeg";
import summary from "../../../assets/ProfileCardimg/summary.jpeg";
import rupee from "../../../assets/icons/rupee.svg";
import phonepe from "../../../assets/icons/phonepe.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PaymentConfirmationModal from "../../../Components/PaymentConfirmationModal";
import {extractParameterIds , generateBillItems} from "../../../Utils/Functions"

const PaymentAndOrderSummary = () => {
  const [billItem, setBillItem] = useState([]);
  const [gstPrice, setGstPrice] = useState(0);
  const [totalCalculated, setToatalCalculate] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [coupon, setCoupon] = useState("");
  const [promoMessage, setPromoMessage] = useState("");
  const [promoDiscount, setPromoDiscount] = useState(0);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [, setValidate] = useState(false);
  const [isPromoApplied, setIsPromoApplied] = useState(false);

  const gstRate = 0;
  const navigate = useNavigate();
    const { testData = [] } = useSelector((state) => state.testDataSlice || {});

  const UserData = useSelector((state) => state.authSlice.user);
  const TestData = useSelector((state) => state.testSlice);
  const PatientData = useSelector((state) => state.patientSlice.patientData);
  // console.log(TestData.testsData, "test data passed from test page ");
  useEffect(() => {
    const fetchData = async () => {
     const ids =   extractParameterIds(TestData.testsData)
      await getPriceOfTests(ids);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TestData.testsData]);

  const calculateGrandTotal = (subtotal, gst, discount = 0) => {
    // console.log(subtotal , "subtotal-11--1")
    return (parseFloat(subtotal) + parseFloat(gst) - parseFloat(discount)).toFixed(2);
  };
  
 // console.log(UserData , '---test---')
  const getPriceOfTests = async (input) => {
    const url = API_ENDPOINTS.calculateTestPrice;
    const data = { CenterID : UserData.CentreID,
      ParameterIDs : input };
    try {
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${UserData.token}`,
          "Content-Type": "application/json",
        },
      });
  
      if (response.status === 200) {
        const priceData = response.data;
        const subtotal = priceData.total;
        const gst = gstRate ? (subtotal * gstRate).toFixed(2) : "0.00";
        setBillItem(generateBillItems(testData,priceData.tests,setToatalCalculate ));      
        setGstPrice(gst);
        // console.log(totalCalculated ," -11-total")
  
     
        // Reset promo state if test changes
        setIsPromoApplied(false);
        setPromoDiscount(0);
        setPromoMessage("");
        setCoupon("");
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

useEffect(()=>{
  if (totalCalculated >= 0) {
    setGrandTotal(calculateGrandTotal(totalCalculated, 0));
  }
},[totalCalculated])

  // console.log(billItem , "setBillItem--11---")
  // console.log(testData , "testData1171727")
  

  const processPayment = async () => {
    const amount = (parseFloat(totalCalculated) - promoDiscount) * 100;
    const requestDataPayment = {
      PatientID: PatientData.PatientID,
      amount,
      paymentMode: "online",
      mobileNumber: PatientData.contactNumber,
      TechnicianID: UserData.LabTechnicianID,
      CenterID: UserData.CentreID,
      paymentBill: billItem,
    };

    try {
      const response = await axios.post(
        `${API_ENDPOINTS.payOnline}`,
        requestDataPayment,
        {
          headers: {
            Authorization: `Bearer ${UserData.token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // // console.log(
      //   "________________________________________________ response.data",
      //   response.data
      // );

      if (response.data?.payUrl?.url) {
        const transactionId = response.data.transactionId;
        window.location.href = `${response.data.payUrl.url}&redirect_url=${window.location.origin}/payment/confirmation?transactionId=${transactionId}`;
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    const amount =
      parseFloat(totalCalculated)  - promoDiscount;
    setMessage(amount);
  }, [open, totalCalculated, promoDiscount]);

  const handleConfirm = async () => {
    const amount = (parseFloat(totalCalculated) - promoDiscount) * 100;

    const requestDataPayment = {
      PatientID: PatientData.PatientID,
      amount,
      paymentMode: "cash",
      mobileNumber: PatientData.contactNumber,
      TechnicianID: UserData.LabTechnicianID,
      CenterID: UserData.CentreID,
      paymentBill: billItem,
    };

    try {
      const response = await axios.post(
        `${API_ENDPOINTS.payOnline}`,
        requestDataPayment,
        {
          headers: {
            Authorization: `Bearer ${UserData.token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // // console.log(
      //   "______________________________________________________________ responce.data of cash",
      //   response.data
      // );

      if (response.data) {
        // // console.log(
        //   "______________________________________________________________ responce.data",
        //   response.data
        // );
   
          // console.log(validate, "validate field ");
          applyPromoCode();
          setOpen(false);
          navigate("/general-test");
       
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const navigateTest = () => {
  //   navigate("/general-test");
  // };

  const checkTransaction = () => {
    // console.log("Check transaction status");
  };

  const checkValidity = async () => {
    try {
      const response = await axios.patch(
        `${API_ENDPOINTS.validatePromoCode}`,
        { code: coupon },
        {
          headers: {
            Authorization: `Bearer ${UserData.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200 && response.data.valid) {
        const discountPercent = response.data.discount || 0;
        const grossTotal = parseFloat(totalCalculated) + parseFloat(gstPrice);
        // :dart: Calculate percentage discount
        const discountAmount = (grossTotal * discountPercent) / 100;
        // const totalAfterDiscount = (grossTotal - discountAmount).toFixed(2);
        setPromoDiscount(discountAmount);
        setValidate(true);
        setIsPromoApplied(true);
        setPromoMessage(`Promo applied: ${discountPercent}% off`);
        setGrandTotal(calculateGrandTotal(totalCalculated, gstPrice, discountAmount));
        // Apply Promo
        // applyPromoCode();
      } else {
        setPromoMessage("Invalid promo code.");
        setValidate(true);
        setPromoDiscount(0);
      }
    } catch (error) {
      console.error("Validation Error:", error);
      setValidate(true);
      setPromoMessage("Failed to validate promo code.");
    }
  };

  const applyPromoCode = async () => {
    try {
      const applyResponse = await axios.post(
        `${API_ENDPOINTS.applyPromoCode}`,
        { code: coupon, PatientID: PatientData.PatientID },
        {
          headers: {
            Authorization: `Bearer ${UserData.token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (applyResponse.status === 200 && !applyResponse.data.error) {
        // console.log("Promo code applied:", applyResponse.data);
        toast.success("Promo code applied successfully!");
      } else {
        toast.error("Failed to apply promo code.");
      }
    } catch (error) {
      console.error("Apply Error:", error);
      // toast.error("Server error while applying promo code.");
    }
  };

  const removePromoCode = () => {
    setIsPromoApplied(false);
    setCoupon("");
    setPromoDiscount(0);
    setPromoMessage("");
    setGrandTotal(calculateGrandTotal(totalCalculated, gstPrice, 0));
  };

  // const checkValidity = async () => {
  //   // // console.log("_____________________ inside check");

  //   try {
  //     const response = await axios.patch(
  //       `${API_ENDPOINTS.promoCode}`,
  //       { code: coupon },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${UserData.token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (response.status === 200 && response.data.valid) {
  //       const discount = response.data.discount || 0;
  //       setPromoDiscount(discount);
  //       setPromoMessage("Promo code applied successfully!");
  //       const total = (
  //         parseFloat(totalCalculated) +
  //         parseFloat(gstPrice) -
  //         discount
  //       ).toFixed(2);
  //       setGrandTotal(total);
  //     } else {
  //       setPromoMessage("Invalid promo code.");
  //       setPromoDiscount(0);
  //     }
  //   } catch (error) {
  //     console.error("Error occurred:", error);
  //     setPromoMessage("Failed to validate promo code.");
  //   }
  // };

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <>
      <div className="flex flex-col md:flex-row gap-6 p-8 bg-[#C7CEE5] min-h-[92vh] items-center justify-center">
        <ToastContainer />
        {/* Order Summary */}
        <div className="bg-[#845BB3] p-8 rounded-xl w-full max-w-md mx-auto text-white shadow-lg">
          <img
            src={summary}
            alt="lab"
            className="w-full h-40 object-cover rounded-xl mb-6"
          />
          <h2 className="text-center text-2xl font-bold mb-4">ORDER SUMMARY</h2>
          <ul className="mb-6">
            {billItem.map((test, index) => (
              <li key={index} className="mb-4">
<div
  className="flex justify-between items-center cursor-pointer"
  onClick={() => toggleExpand(index)}
>
  <span>{test.testFieldName}</span>
  <span className="flex items-center gap-1 text-white">
    ₹ {test.totalPrice}
    <ChevronDown className="w-4 h-4" />
  </span>
</div>

                {expandedIndex === index && (
                  <ul className="mt-2 ml-4 text-sm text-gray-200">
                    {test.totalSubfields.map((subfield, subIndex) => (
                      <li key={subIndex} className="flex justify-between mb-1">
                        <span>{subfield.fieldName}</span>
                        <span>₹ {subfield.fieldPrice}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
          <hr />
          <div className="flex justify-between items-center mb-2">
            <span>Subtotal</span>
            <span>₹ {totalCalculated}</span>
          </div>
          {/* <div className="flex justify-between items-center mb-2">
          <span>GST</span>
          <span>₹ {gstPrice}</span>
        </div> */}
          {promoDiscount > 0 && (
            <div className="flex justify-between items-center mb-2 text-green-400">
              <span>Promo Code Discount</span>
              <span>- ₹ {promoDiscount}</span>
            </div>
          )}
          <div className="flex justify-between items-center text-lg font-bold">
            <span>Total</span>
            <span>₹ {grandTotal}</span>
          </div>
          <div className="mt-4">
  <input
    type="text"
    placeholder="Enter Promo Code"
    value={coupon}
    onChange={(e) => setCoupon(e.target.value)}
    className="w-full p-3 rounded-lg text-black mb-2"
    disabled={isPromoApplied}
  />
  {promoMessage && (
    <p
      className={`text-xl mt-0 mb-3 ${
        promoDiscount > 0 ? "text-green-500" : "text-red-600 bg-white p-2"
      }`}
    >
      {promoMessage}
    </p>
  )}

  {isPromoApplied ? (
    <button
      onClick={removePromoCode}
      className="w-full py-3 bg-red-500 text-white rounded-lg hover:bg-red-700"
    >
      Remove Promo Code
    </button>
  ) : (
    <button
      onClick={checkValidity}
      className="w-full py-3 bg-[#7d57e6] text-white rounded-lg hover:bg-[#5a3dbf]"
      disabled={!coupon}
    >
      Validate Promo Code
    </button>
  )}
</div>

        </div>

        {/* Payment Details */}
        <div className="bg-[#f3f1fc] z-10 p-8 rounded-xl w-full max-w-md mx-auto shadow-lg">
          <img
            src={coin}
            alt="coin"
            className="w-full h-40 object-cover rounded-xl mb-6"
          />
          <h2 className="text-center text-2xl font-bold text-[#7d57e6] mb-4">
            PAYMENT DETAILS
          </h2>
          <p className="text-center text-sm text-gray-600 mb-6">
            Choose your payment methods
          </p>
          <div className="flex justify-center gap-6 mb-6">
            <button
              className="text-white rounded-lg h-20 w-20 px-6 py-6 border hover:border-4 border-[#5a3dbf] font-semibold transition"
              onClick={() => setOpen(true)}
            >
              <img
                src={rupee}
                alt="coin"
                className="w-full object-cover rounded-md"
              />
            </button>
            <button
              className="bg-[#9372ec] rounded-lg h-20 w-20 px-4 py-4 border hover:border-4 border-[#5a3dbf] font-semibold transition"
              onClick={processPayment}
            >
              <img
                src={phonepe}
                alt="coin"
                className="w-full object-cover rounded-md"
              />
            </button>
          </div>
          {/* <p className="text-center text-sm text-[#ff0000] mb-6">
          Your Payment Has Been Failed, Please Try Again - Money Deducted from
          your account? Contact Us.
        </p> */}
          <input
            type="text"
            placeholder="Enter Transaction ID"
            className="w-full border border-gray-300 rounded-xl p-3 mb-6 focus:outline-none focus:ring-2 focus:ring-[#7d57e6]"
          />
          <div className="flex justify-center">
            <button
              className="bg-[#7d57e6] text-white py-3 px-12 rounded-lg font-semibold hover:bg-[#5a3dbf] transition"
              onClick={checkTransaction}
            >
              Check Status
            </button>
          </div>
        </div>

        {/* Help Icon */}
        {/* <Link to="../faq" className="fixed z-10 bottom-8 right-28">
        <img src={help} alt="helpicon" className="w-10 lg:w-12" />
        </Link>
        <div className="absolute bottom-0 right-0 z-0 w-full lg:w-auto">
        <img src={sidevector} alt="sidevector" className="w-full lg:w-auto" />
        </div> */}
      </div>
      <PaymentConfirmationModal
        isOpen={open}
        onConfirm={handleConfirm}
        onCancel={() => setOpen(false)}
        message={message}
      />
    </>
  );
};

export default PaymentAndOrderSummary;
